import { DeviceChecker } from './deviceChecker';
const deviceChecker = new DeviceChecker();

/**
 * PC版とSP版の画像を自動で切り替えるクラス
 * - 画像のファイル名に _pc / _sp を付加して切り替える
 */
export class ImgSwitcher {
    constructor() {
        // PC版画像の識別文字列
        this.pcName = '_pc';

        // SP版画像の識別文字列
        this.spName = '_sp';

        // 初期化
        this._init();
    }

    /**
     * 初期化メソッド
     * - window load / resize 時に画像を切り替える
     */
    _init() {
        $(window).on('load resize', deviceChecker._debounce(() => {
            // class="switch" が付いた画像をすべて対象
            $('.switch').each((index, element) => {
                const $element = $(element);
                const currentSrc = $element.attr('src');

                // デバイス判定に応じて src を置換
                if (deviceChecker._isMobile()) {
                    // モバイルなら _pc → _sp に変更
                    $element.attr('src', currentSrc.replace(this.pcName, this.spName));
                } else {
                    // PCなら _sp → _pc に変更
                    $element.attr('src', currentSrc.replace(this.spName, this.pcName));
                }

                // アクセシビリティ対応: alt 属性の確認
                if (!$element.attr('alt')) {
                    console.warn(`画像にalt属性が設定されていません: ${currentSrc}`);
                }

                // alt が設定されていれば表示可能にする
                if ($element.attr('alt')) {
                    $element.css({ visibility: 'visible' });
                }
            });
        }, 200)); // デバイス判定は 200ms のデバウンスで間引き
    }
}
